import { useTranslation } from "react-i18next";
import { errorMessage } from "@/api/errors";
import { Banner } from "@/components/ui/banner";

export function ErrorNotice({ error }: { error: unknown }) {
  const { t } = useTranslation();
  return <Banner tone="danger">{errorMessage(error, t("errors.generic"))}</Banner>;
}
